/**
 * Footer: just sets the copyright year and any runtime details.
 * Markup lives in index.html.
 */
export function mountFooter(): void {
  const yearEl = document.getElementById('footer-year')
  if (yearEl) yearEl.textContent = String(new Date().getFullYear())
}
